import React, { Component } from "react";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroller";

import {
  setArticlesPaginationPage,
  initArticles,
  clearArticleItems,
} from "actions";
import { fetchArticles } from "thunks";
import NotFound from "notFound/NotFound";
import ArticleItem from "./ArticleItem";
import ArticleItemFetching from "fetching/blocks/ArticleItemFetching";
import ArticlesListFilter from "./ArticlesListFilter";
import { formatArticle } from "../../services/article";

const mapStateToProps = (state, ownProps) => ({
  articles: state.articles.items,
  nbResult: state.articles.nbResult,
  filter: state.articles.filter,
  fetching: state.articles.fetching,
  fetched: state.articles.fetched,
  error: state.articles.error,
  lng: state.params.lng,
  viewMode: state.themes.newsletter.viewMode,
});

const mapDispatchToProps = (dispatch) => ({
  fetchArticles: () => dispatch(fetchArticles()),
  setArticlesPaginationPage: (page) =>
    dispatch(setArticlesPaginationPage(page)),
  initArticles: () => dispatch(initArticles()),
  clearArticleItems: () => dispatch(clearArticleItems()),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class ArticlesList extends Component {
  state = {
    hasMoreItems: true,
  };

  isLoadingMore = false;

  componentDidMount() {
    const { fetchArticles, initArticles } = this.props;
    initArticles();
    fetchArticles();
  }

  componentDidUpdate(prevProps) {
    const {
      filter,
      fetchArticles,
      fetching,
      setArticlesPaginationPage,
      clearArticleItems,
    } = this.props;

    if (filter !== prevProps.filter) {
      const categoriesChanged =
        JSON.stringify(filter.categories) !==
        JSON.stringify(prevProps.filter.categories);
      const tagsChanged =
        JSON.stringify(filter.tags) !== JSON.stringify(prevProps.filter.tags);
      const articlePagesChanged =
        JSON.stringify(filter.articlePages) !==
        JSON.stringify(prevProps.filter.articlePages);
      const languagesChanged =
        JSON.stringify(filter.language) !==
        JSON.stringify(prevProps.filter.language);
      const searchWordChanged =
        filter.searchWord !== prevProps.filter.searchWord;

      if (
        categoriesChanged ||
        tagsChanged ||
        articlePagesChanged ||
        languagesChanged ||
        searchWordChanged
      ) {
        clearArticleItems();
        setArticlesPaginationPage(1);
        return;
      }

      fetchArticles();
    }

    if (fetching !== prevProps.fetching) {
      if (!fetching) {
        this.isLoadingMore = false;
      }
      this.setState({
        hasMoreItems: !fetching,
      });
    }
  }

  componentWillUnmount() {
    this.props.initArticles();
  }

  loadItems = () => {
    const { filter, fetching, nbResult, articles, setArticlesPaginationPage } =
      this.props;
    const { hasMoreItems } = this.state;

    if (
      this.isLoadingMore ||
      !hasMoreItems ||
      fetching ||
      articles.length >= nbResult
    ) {
      return;
    }

    this.isLoadingMore = true;
    this.setState({ hasMoreItems: false });
    setArticlesPaginationPage(filter.paginationPage + 1);
  };

  render() {
    const {
      articles,
      fetching,
      viewMode,
      selectedFeeds,
      showSelected,
    } = this.props;
    const { hasMoreItems } = this.state;
    const listMode = viewMode === "LIST";
    let items = [];
    let selectedFeedsIds = [];

    if (showSelected && selectedFeeds?.length > 0) {
      selectedFeeds
        .filter((item) => Object.keys(item).length)
        .forEach((item) => {
          selectedFeedsIds.push(item.id);
        });
    }

    if (articles && articles.length > 0) {
      articles
        .filter(({ id }) => !selectedFeedsIds.includes(id))
        .forEach((item) => {
          items.push(
            <ArticleItem
              viewMode={viewMode}
              order={1000}
              key={`article-${item.id}`}
              article={formatArticle(item)}
            />,
          );
        });
    }

    if (fetching) {
      let itemNbr = listMode ? 5 : 10;
      for (let i = 0; i < itemNbr; i++) {
        items.push(
          <div
            key={`fetch-${i}`}
            className={`medium-${listMode ? 12 : 6} column`}
            style={{ order: 1001 }}
          >
            <ArticleItemFetching />
          </div>,
        );
      }
    }

    const showArticles = items && items.length > 0;

    return (
      <div className="medium-12">
        <div
          id="feeds-container"
          style={{
            height: `${!fetching ? 0.9 * window.innerHeight - 20 : 0.8 * window.innerHeight - 20}px`,
          }}
          ref={(ref) => (this.scrollParentRef = ref)}
          className="column"
        >
          <ArticlesListFilter />

          <div
            className="feeds-list"
            style={{
              width: showSelected && selectedFeeds?.length > 0 ? "100%" : "unset",
            }}
          >
            {showSelected && selectedFeeds?.length > 0 && (
              <div
                className={"masonry-separator medium-12"}
                style={{ backgroundColor: "#dfd2d2" }}
              />
            )}

            {showSelected && selectedFeeds?.length > 0 &&
              selectedFeeds
                .filter((item) => Object.keys(item).length)
                .map((item, index) => (
                  <ArticleItem
                    viewMode={viewMode}
                    order={index}
                    isSelected
                    key={`article-${item.id}-selected`}
                    article={item}
                  />
                ))}
          </div>

          {showArticles ? (
            <InfiniteScroll
              className={"feeds-list"}
              pageStart={0}
              loadMore={this.loadItems}
              hasMore={hasMoreItems}
              useWindow={false}
              getScrollParent={() => this.scrollParentRef}
            >
              {items}
            </InfiniteScroll>
          ) : (
            <NotFound />
          )}
        </div>
      </div>
    );
  }
}
